module.exports = __webpack_public_path__ + "static/media/closeMsg.ab805334.svg";